// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__bQQa6","content":"LoadingAlert_content__-wG-t"};